<template>
  <div id="app">
    <div class="locale-changer" style="text-align: right;
    position: relative;
    right: 40px;
    top: 22px;
    z-index: 1000;
    width: 150px;
    float: right;">
      <div style="font-size: 12px; position: absolute; top: -20px; right: 0px; font-weight: bold; color: #000;">
      {{ $t('choose_your_language') }}
      </div>
      <select v-model="$i18n.locale" v-on:change="redirectLanguage()">
        <option
          v-for="(lang, i) in langs"
          :key="`Lang${i}`"
          :value="lang"
          >{{ lang }}
        </option>
      </select>
    </div>
    <topbar v-if="!$route.meta.admin"/>
    <navbar v-else-if="!$route.meta.hideNavigation"/>
    <router-view/>
    <footbar v-if="!$route.meta.admin"/>
  </div>
</template>

<script>
import Topbar from '@/core/topbar.vue'
import Footbar from '@/core/footbar.vue'
import Navbar from '@/core/Admin/navbar.vue'
import $ from 'jquery'

export default {
  name: 'App',
  components: {
    Topbar,
    Footbar,
    Navbar
  },
  data(){
    return {
      isAdminPage: this.$route.meta.admin,
      langs: ['id', 'en']
    }
  },
  mounted(){
    if(this.$route.meta.admin){
      $('body').addClass('fixed-nav sticky-footer');
    } else {
      $('body').removeClass('fixed-nav sticky-footer');
    }
  },
  watch: {
    isAdminPage: function(val){
      if(val == true){
        $('body').addClass('fixed-nav sticky-footer');
      } else {
        $('body').removeClass('fixed-nav sticky-footer');
      }
    }
  },
  methods: {
    async redirectLanguage() {
      this.$router.push({name: this.$router.currentRoute.name, params: { lang: this.$i18n.locale }})
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800');
@import url('/assets/css/bootstrap.min.css');
@import url('/assets/css/style.css');
@import url('/assets/css/menu.css');
@import url('/assets/css/menu_footer.css');
@import url('/assets/css/vendors.css');
@import url('/assets/css/icon_fonts/css/all_icons_min.css');
@import url('/assets/css/custom.css');
@import url('/assets/css/dev_custom.css');
@import url('/assets/css/admin/custom.css');
@import url('/assets/css/admin/admin.css');
@import url('../static/bootstrap/css/bootstrap.min.css');
@import url('../static/bootstrap/css/bootstrap.css');
@import url('../static/font-awesome/css/font-awesome.min.css');

#app {
  font-family: 'Gotham-Light';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

@font-face {
  font-family: Gotham-Bold;
  src: url('assets/font/Gotham-Bold.otf');
}
@font-face {
  font-family: Gotham-Black;
  src: url('assets/font/Gotham-Black.otf');
}
@font-face {
  font-family: Gotham-Light;
  src: url('assets/font/Gotham-Light.otf');
}
@font-face {
  font-family: Gotham-Thin;
  src: url('assets/font/Gotham-Thin.otf');
}
@font-face {
  font-family: Gotham-XLight;
  src: url('assets/font/Gotham-XLight.otf');
}
.content-wrapper {
  height: 100vh;
  width: calc(100% - 250px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue